
    import Vue from 'vue';
    import { PropType } from 'vue';
    import FilePathService from '@/apps/shared/services/filePath-service';
    export default Vue.extend({
        name: 'ModalCancel',
        props: {
            product: {
                type: String as PropType<string>,
                required: true,
            },
        },
        data() {
            return {
            }
        },
        methods: {
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + this.product;
                    });
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },        
        },
        mounted() {
            sessionStorage.setItem("ExitOrContinueModal", "true")
        },
    });
